module.exports = __webpack_public_path__ + "img/stand_boluo_2.94828a17.jpg";